import { Box, Divider, MenuItem, Typography } from "@mui/material";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import SidebarPortal from "../../dashboard/general/Sidebar/Sidebar";
import WakatobiLogo from "../../../static/img/wakatobi-logo-2.svg";
import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { LogoutCurve, User } from "iconsax-react";
import stepIconActive from "../../../static/img/icons/step-icon-active.svg";
import stepIconDeactive from "../../../static/img/icons/step-icon-deactive.svg";
import stepIconFinish from "../../../static/img/icons/step-icon-finish.svg";
import "./styles.css";
import LanguageSwitcher from "../../languageSwitcher";
import { useTranslation } from "react-i18next";

const Sidebar = ({ mainContact }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const { URL_PREFIX } = window;
  
  const getFullPath = (path) => `${URL_PREFIX}/vf2/wizard${path}`;

  const getStatus = (paths) => {
    if (location.pathname === paths[0]) {
      return "current";
    }
    if (paths.slice(1).some(path => location.pathname.includes(path))) {
      return "done";
    }
    return "undone";
  };

  const sidebarItem = [
    {
      label: t("Personal Information"),
      url: mainContact ? '/personal': '/',
      status: mainContact
        ? (location.pathname === getFullPath('/personal') ? "current" 
          : getFullPath('') === location.pathname ? "undone" : "done")
        : (location.pathname === getFullPath('') ? "current" : "done"),
    },
    {
      label: t("Snorkeling / Diving Skills and Preference"),
      url: '/diving',
      status: getStatus([
        getFullPath('/diving'),
        getFullPath('/stay'),
        getFullPath('/flight'),
        getFullPath('/summary'),
        getFullPath('/finish')
      ]),
    },
    {
      label: t("Stay Preference"),
      url: '/stay',
      status: getStatus([
        getFullPath('/stay'),
        getFullPath('/flight'),
        getFullPath('/summary'),
        getFullPath('/finish')
      ]),
    },
    {
      label: t("Flight and other changes"),
      url: '/flight',
      status: getStatus([
        getFullPath('/flight'),
        getFullPath('/summary'),
        getFullPath('/finish')
      ]),
    },
    {
      label: t("Summary"),
      url: '/summary',
      status: getStatus([
        getFullPath('/summary'),
        getFullPath('/finish')
      ]),
    },
    {
      label: t("Finish"),
      url: '/finish',
      status: location.pathname === getFullPath('/finish') ? "current" : "undone",
      lastStep: true,
    },
  ];
  return (
    <SidebarPortal>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column", // Stack elements vertically
          minHeight: "100%", // Sidebar grows to fit content
          padding: "0 24px",
        }}
      >
        {/* Logo Section */}
        <Box
          sx={{
            marginLeft: "20px",
            height: 50,
            marginTop: "30px",
            marginBottom: "30px",
          }}
        >
          <img src={WakatobiLogo} alt="Logo waka" width="90%" />
        </Box>

        {/* Guest Menu */}
        {mainContact && (
          <Box>
            <Typography className="section-sidebar">{t("Guest Menu")}</Typography>
            <Link
              style={{
                textDecoration: "none",
                display: "inline-block",
                marginTop: "5px",
                width: "100%",
              }}
              to={`${URL_PREFIX}/vf2/wizard`}
            >
              <MenuItem>
                <User color="#134264" />
                <Typography
                  className="timeline-label"
                  sx={{ marginLeft: "10px" }}
                >
                  {t("Guest List")}
                </Typography>
              </MenuItem>
            </Link>
          </Box>
        )}

        {/* Form Navigation */}
        <Box sx={{ flex: "1 1 auto", overflowY: "auto" }}>
          <Typography className="section-sidebar">{t("Form Navigation")}</Typography>
          <Timeline>
            {sidebarItem.map((item, i) => (
              <div key={i}>
                <TimelineItem>
                  <TimelineSeparator>
                    {item.lastStep && item.status === "current" ? (
                      <Link to={`${URL_PREFIX}/vf2/wizard${item.url}`}>
                        <img src={stepIconFinish} alt="icon" />
                      </Link>
                    ) : item.status === "current" ? (
                      <img src={stepIconActive} alt="icon"/>
                    ) : item.status === "undone" ? (
                      <img src={stepIconDeactive} alt="icon"/>
                    ) : (
                       <Link to={`${URL_PREFIX}/vf2/wizard${item.url}`}>
                        <img src={stepIconFinish} alt="icon"/>
                      </Link>
                    )}

                    {!item.lastStep && (
                      <TimelineConnector
                        sx={{ background: "#134264", height: "5px" }}
                      />
                    )}
                  </TimelineSeparator>
                  <TimelineContent sx={{ padding: 0, marginLeft: "10px" }}>
                    {
                      item.status === "done" ? 
                        <Link to={`${URL_PREFIX}/vf2/wizard${item.url}`}>
                          <Typography className="timeline-label">
                            {item.label}
                          </Typography>
                        </Link> : 
                        <Typography className="timeline-label">
                          {item.label}
                        </Typography>
                    }
                    
                  </TimelineContent>
                </TimelineItem>
              </div>
            ))}
          </Timeline>
        </Box>

        {/* Footer Section */}
        <Box
          sx={{
            marginTop: "auto", // Push footer to bottom if there's space
            paddingTop: "20px",
          }}
        >
          <Box sx={{ paddingBottom: "10px" }}>
            <LanguageSwitcher style={{width: '100%', padding: "0px 12px", height: 50}} variant="outline"/>
          </Box>
          <Box sx={{ paddingBottom: "30px" }}>
            <a
              style={{
                textDecoration: "none",
                display: "inline-block",
                marginTop: "5px",
                width: "100%",
              }}
              href={`${URL_PREFIX}/vf2/logout`}
            >
              <MenuItem>
                <LogoutCurve color="#134264" />
                <Typography
                  className="timeline-label"
                  sx={{ marginLeft: "10px" }}
                >
                  {t("Exit")}
                </Typography>
              </MenuItem>
            </a>

          </Box>
        </Box>
      </Box>
    </SidebarPortal>
  );
};

export default Sidebar;
